import { css, styled } from '@elliemae/ds-system';
import { DSButtonV2 } from '@elliemae/ds-button-v2';

import type { DSTabsInternalsT } from '../../sharedTypes.js';
import { DSTabsName, TABS_SLOTS, TAB_TYPES } from '../../constants/index.js';

interface StyledCarouselButtonWrapperPropsT {
  right?: boolean;
  tabType: DSTabsInternalsT.TabTypesT;
}

const baseCarouselButtonStyles = css`
  margin: 0;
  min-width: ${({ theme }) => theme.space.xs};
  width: ${({ theme }) => theme.space.xs};

  &:hover:not(:disabled) {
    background-color: transparent;
  }
  background-color: transparent;
  border-radius: 0px;

  & .em-ds-icon svg {
    fill: ${({ theme }) => theme.colors.brand[600]};
  }
`;

export const StyledCarouselBtnLeft = styled(DSButtonV2, {
  name: DSTabsName,
  slot: TABS_SLOTS.CAROUSEL_BUTTON_LEFT,
})`
  ${baseCarouselButtonStyles}
`;

export const StyledCarouselBtnRight = styled(DSButtonV2, {
  name: DSTabsName,
  slot: TABS_SLOTS.CAROUSEL_BUTTON_RIGHT,
})`
  ${baseCarouselButtonStyles}
`;

export const StyledCarouselWrapper = styled.span`
  position: relative;
  width: 100%;
  display: flex;
`;

export const StyledChildrenWrap = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex: 1;
  overflow-x: hidden;
`;

export const StyledCarouselButtonWrapper = styled.div<StyledCarouselButtonWrapperPropsT>`
  max-width: 16px;
  position: absolute;
  z-index: 200;
  ${({ right }) => (right ? 'right: 0;' : `left: 0;`)}
  width: 16px;
  height: ${({ tabType }) => (tabType === TAB_TYPES.NORMAL ? '32px' : '22px')};
  padding-top: ${({ tabType }) => (tabType === TAB_TYPES.NORMAL ? '5px' : '0px')};
  background: white;
  ${({ theme, tabType }) =>
    tabType === TAB_TYPES.NORMAL
      ? `
      background: linear-gradient(to bottom, white 0px, white 30px, ${theme.colors.neutral[400]} 30px, ${theme.colors.neutral[400]} 31px, white 31px , white 32px );
 `
      : ``};
`;
